import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import confirm from '#utilities/js/ea/confirm.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import { onTapDown, onTapUp } from '#components/generics/js/modal/backdrop/backdrop.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import { elements, helpers } from '../../styles.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { elements as elementsXfiles } from '../styles.js'
import all from '@mailobj-browser/front/js/selectors/all.js'

let itemsSelected = []

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    backdrop,
    event
  ) => {
    const modal = closest(`.${elements.modal}`, backdrop)
    const xfilesAttach = one(`[data-show-xfiles]`, modal)
    const { dataset } = backdrop
    const { confirm: confirmMessage } = dataset
    const { title, text } = JSON.parse(confirmMessage)

    hasAttachedFile(modal)

    if (xfilesAttach.classList.contains(helpers.xfiles.elements.xfiles_attach_has_file_attached)) {
      if (await confirm(title, text, [backdrop])) {
        onTapDown.task(backdrop, event)
        onTapUp.task(backdrop, event)
      }
    } else {
      onTapDown.task(backdrop, event)
      onTapUp.task(backdrop, event)
    }
  }
})

const onClickDialog = object(listener, {
  type: click,
  passive,
  hooks: array([
    stopImmediatePropagation
  ]),
  task() {}
})

export const hasAttachedFile = (modal => {
  const itemsSelectable = all(`.${elementsXfiles.xfiles_attach_item_selectable}`, modal)
  const xfilesAttach = one(`[data-show-xfiles]`, modal)
  const canvas = one(`.${elementsXfiles.xfiles_attach_draw_canvas}`, xfilesAttach)
  const cameraContainer = one(`[data-show-xfiles='camera']`, modal)
  const xfilesUploads = one(`.${elementsXfiles.xfiles_uploads}`, xfilesAttach)
  let hasInputFileAttached = false

  itemsSelected = []

  // Check if inputs are filled
  // From docs, attach, vcard and pgp
  if (itemsSelectable.length > 0) {
    for (const itemSelectable of itemsSelectable) {
      if (one(`input`, itemSelectable).checked === true) {
        itemsSelected.push(one(`input`, itemSelectable))
      }
    }
  }

  // File from device, camera and draw
  // then display confirm
  if (xfilesUploads) {
    for (const checkboxUpload of all('input[type="checkbox"]', xfilesUploads)) {
      if (checkboxUpload) {
        hasInputFileAttached = true
        break;
      }
    }
  }

  if (hasInputFileAttached
    || (itemsSelected && itemsSelected.length > 0)
    || (canvas && canvas.classList.contains(elementsXfiles.xfiles_attach_draw_canvas_drawn))
    || (cameraContainer && one('[type="hidden"][name="upload_camera_data"]', cameraContainer).value !== '')) {
    xfilesAttach.classList.add(elementsXfiles.xfiles_attach_has_file_attached)
  } else {
    xfilesAttach.classList.remove(elementsXfiles.xfiles_attach_has_file_attached)
  }
})

export default (
  backdrop
) => {
  const dialog = one('dialog', backdrop)

  onClickDialog.listen(dialog)
  onClick.listen(backdrop)
}